export const NAVIGATION_BADGE = 'navigation_badge';
export const NAVIGATION_BADGE_NO_BADGE = 'navigation_badge_no_badge';
